import { OrderUpsell } from '@models/order-upsell';
import { UpsellStoreRequest } from '@models/requests/upsell-store.model';

/**
 * The body of the request that stores several upsells on an order in a single batch.
 */
export class UpsellBatchStoreRequest {
  public tests: UpsellStoreRequest[];

  public constructor(orderUpsells: OrderUpsell[]) {
    this.tests = orderUpsells.map((orderUpsell) => new UpsellStoreRequest(orderUpsell));
  }
}
